'use client'

import { useAtomValue, useSetAtom } from 'jotai'
import { usePathname, useRouter } from 'next/navigation'
import { useCallback } from 'react'

import { activePageIdAtom } from '@/state/dashboard-layouts'
import { welcomeGuideRequestedAtom } from '@/state/onboarding'

/**
 * Opens the welcome tour on the user's dashboard page: what it points at (the page's widgets,
 * the header's search and hide-balances, a link dot) only exists there, so from anywhere else
 * this goes to the page first. The request is an atom, so the tour is waiting when it mounts.
 */
export function useStartWelcomeTour() {
  const request = useSetAtom(welcomeGuideRequestedAtom)
  const activePageId = useAtomValue(activePageIdAtom)
  const pathname = usePathname()
  const router = useRouter()
  return useCallback(() => {
    request(true)
    const dashboard = activePageId ? `/trade/${activePageId}` : '/trade'
    if (pathname !== dashboard) router.push(dashboard)
  }, [request, activePageId, pathname, router])
}
